import { mapGetters, mapActions } from 'vuex';
import Service from '@/components/Services/ServiceWrapper/Service';

export default {
  name: 'ServiceWrapper',
  components: {
    Service,
  },
  props: {
    services: {
      type: Array,
      default: (() => []),
    },
    activePackage: {
      type: Object,
      default: (() => {
      }),
    },
    isPromotion: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hover: false,
    };
  },
  computed: {
    ...mapGetters(['packageUsage', 'getUsageLoading',
    ]),
    checkIfUsageInStore() {
      return !Object.keys(this.packageUsage).length;
    },
  },
  created() {
  },
  methods: {
    ...mapActions(['getPackageUsage']),
    async checkUsage() {
      const param = {
        feature: this.activePackage.uuid,
      };
      await this.getPackageUsage(param);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Services/ServiceWrapper/component.js